import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import moment from "moment";
import {
  getPastOrderById,
  getAnswer,
  getAccountingInformation,
} from "../../../service/PastOrder/PastOrderService";
import { object } from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import {
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
  Nav,
  Button,
} from "react-bootstrap";
import SpinnerComponent from "../../components/SpinnerComponent";
import instance from "../../../WebApi/WebApi";
import countryLocales from "../invoice/Locale";
import { getAllCurrencylist } from "../../../service/Currency/CurrencyService";
import { useTranslation } from "react-i18next";
import { FUEL_TYPE, TRANSPORT_TYPE } from "../utils/constant";
const Pastorderdetail = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("link-1");
  const [isActive, setActive] = useState("false");
  const [logs, setLogs] = useState(false);
  const [status, setStatus] = useState("");
  const [pastOrderList, setAllPastOrderList] = useState([]);
  const [accountingInformation, setAccountingInformation] = useState([]);
  const location = useLocation();
  const pastOrderId = new URLSearchParams(location.search);
  // console.log(pastOrderId.get(`id`), "pastOrderId")
  const navigate = useNavigate();
  // For toggle
  const [isToggled, setToggled] = useState(false);
  const [getPastOrderId, setPastOrderId] = useState([]);
  const [accoutingInfoType, setAccoutingInfoType] = useState("businessUnit");
  const [allData, setAllData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [comments, setComments] = useState({
    commentk: "",
  });
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [purchaseHistoriesModal, setPurchaseHistoryModal] = useState(false);
  const [commentk, setCommentEdit] = useState("");
  const [allLogs, setAllLogs] = useState();
  const [currencyData, setCurrencyData] = useState([]);
  const [emissionData, setEmissionData] = useState([
    { transport_type: "", transport_fuel: "", transport_distance: "" },
  ]);
  const [wasteData, setWasteData] = useState([
    { material_type: "", quantity: "" },
  ]);

  // const handleToggle = (e) => {
  //     // setToggled(true);
  //     // setToggled(false);
  //     const { name, value } = e.target
  //     console.log(name,value,"mna")

  //     setAllData((prevFormData) => ({
  //         ...prevFormData,
  //         [name]: {
  //         //   ...prevFormData[key],
  //           [name]: value
  //         },
  //       }));
  // };

  const handleToggle = (e, qualityControlId) => {
    const value = e.target.value; // Convert the string to a boolean

    setAllData((prevState) => ({
      ...prevState,
      [qualityControlId]: {
        answer: value,
        qualityControlId: qualityControlId,
        pastOrderId: pastOrderId.get(`id`),
      },
    }));
  };

  // console.log(allData, "allData")

  const _FETCH_ACCOUTING_INFO = async () => {
    setIsLoading(true);
    getAccountingInformation(pastOrderId.get(`id`), (res) => {
      setAccountingInformation(res.data.products);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getallPastOrderList();
    getAllLogs();
  }, []);

  useEffect(() => {
    _FETCH_ACCOUTING_INFO();
    getCurrencyDataList();
  }, []);
  async function getCurrencyDataList() {
    getAllCurrencylist().then(function (result) {
      // console.log(result?.data, "datadatadatadatada")
      const response = result?.data;

      const defaultCurrencyData = response?.data?.currencyList.filter(
        (item) => item.defaultCurrency
      );
      setCurrencyData(defaultCurrencyData);
      console.log("defaultCurrencyData", defaultCurrencyData);
    });
  }

  const getAllLogs = async () => {
    const data = {
      pastOrderId: pastOrderId.get(`id`),
    };
    try {
      const response = await instance.post(
        `/customer/past-order/get-past-order-logs`,
        data
      );
      console.log("response-->", response);
      if (response?.data?.success) {
        setAllLogs(response?.data?.data?.pastOrderDetails);
        const commentData =
          response?.data?.data?.pastOrderDetails?.CommentsLogs;
        setCommentEdit(commentData[commentData.length - 1]?.comments);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  //    const [qc,setQc]=useState([]);
  function getallPastOrderList() {
    setIsLoading(true);
    getPastOrderById(pastOrderId.get(`id`), pastOrderId.get(`invoiceId`)).then(
      function (result) {
        const response = result.data;
        // console.log(response, "response")
        setPastOrderId(response?.data?.pastOrderDetails);
        setPastOrderId(response?.data?.pastOrderDetails);
        setEmissionData(
          response?.data?.pastOrderDetails?.transportEmission || [
            { transport_type: "", transport_fuel: "", transport_distance: "" },
          ]
        );
        // console.log(response?.data?.pastOrderDetails?.SelectedPastOrderQualityControls,"ffggg");
        // const lastElement =
        //   response?.data?.pastOrderDetails?.CommentsLogs[
        //     response?.data?.pastOrderDetails?.CommentsLogs.length - 1
        //   ];
        // setComments({ ...comments, commentk: lastElement?.comments });
        setStatus(response?.data?.pastOrderDetails?.orderStatus);
        // setAllPastOrderList()
        // console.log(response?.data?.pastOrderDetails,"KKKKKKKKKKKKKK")
        // setDepartmentId(response?.data?.businessUnit?.Departments);
        setIsLoading(false);
      }
    );
  }

  // console.log(getPastOrderId, "getPastOrderId")

  const onSubmit = () => {
    // "QCAnser":[
    //     {"answer":"Yes","qualityControlId":12,"pastOrderId":36},
    //     {"answer":"No","qualityControlId":11,"pastOrderId":36}
    // ]
    setIsLoading(true);

    const QCAnser = [];
    Object.values(allData).map((data) => QCAnser.push(data));

    const data = {
      QCAnser: QCAnser,
    };
    getAnswer(data, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        navigate("/pastorder");
        setIsLoading(false);
      } else {
        toast.error(r.message);
      }
    });
  };
  const onLogs = () => {
    // setQc(pastOrderId?.SelectedPastOrderQualityControls)
    setLogs(true);
  };
  const handleCloseLogs = () => setLogs(false);
  // console.log(accoutingInfoType, "accoutingInfoType")
  const handleSelect = async (eventKey) => {
    console.log("eventKey", eventKey);
    setIsLoading(true);

    // Map the event keys to their respective URLs
    const urlMap = {
      "link-1": "/customer/past-order/get-past-order-logs",
      "link-2": "/customer/past-order/get-past-order-comment-logs",
      "link-3": "/customer/past-order/get-past-order-order-logs",
      "link-4": "/customer/past-order/get-past-order-quantity-logs",
      "link-5": "/customer/past-order/get-past-order-business-logs",
      "link-6": "/customer/past-order/get-past-order-ghg-logs",
      "link-7": "/customer/past-order/get-past-order-delivery-logs",
    };
    const url = urlMap[eventKey];

    if (!url) {
      console.error("Invalid eventKey provided.");
      return;
    }

    // Prepare the data payload
    const data = {
      pastOrderId: pastOrderId.get(`id`),
    };

    try {
      // Call the API using the selected URL
      const response = await instance.post(url, data);
      console.log("response", response);
      setAllLogs(response?.data?.data?.pastOrderDetails);

      // Set the active tab if API call is successful
      setActiveTab(eventKey);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error in API call", error);
    }
  };

  const formatCurrency = (amount, currency = "USD") => {
    console.log("amount", amount);
    const selectedLocale = countryLocales.find(
      (item) => item.country === currency
    )?.code;

    return new Intl.NumberFormat(selectedLocale, {
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const handlePurchaseHistory = async (text) => {
    const data = {
      pastOrderId: pastOrderId.get(`id`),
      productName: text,
    };
    try {
      const response = await instance.post(
        `/customer/past-order/past-order-product-purchase-history`,
        data
      );
      setPurchaseHistory(response?.data?.data?.purchaseHistories);
      setPurchaseHistoryModal(true);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="dbMain  pastorder">
          <Leftpanel />
          <div className="dbRight">
            <Header
              link="/pastorder"
              breadcm=""
              title={t("pastOrderDetails")}
              description=""
            />
            <div className="commonBase mb-3">
              {isLoading && <SpinnerComponent isLoading={isLoading} />}
              <div className="row orderDetl">
                <div className="col-md-6">
                  <h5>
                    {
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingCustomerParty?.Party?.PartyName?.Name?._text
                    }
                  </h5>
                  <h5>
                    {!getPastOrderId?.Department
                      ? getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PartyName?.Name
                          ?._text
                      : getPastOrderId?.Department?.BusinessUnit?.name}
                  </h5>
                  <h5>
                    {!getPastOrderId?.Department
                      ? ""
                      : `${getPastOrderId?.Department.name}`}
                  </h5>
                  <p>
                    {!getPastOrderId?.Department
                      ? getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.StreetName?._text
                      : getPastOrderId?.Department?.BusinessUnit?.address}
                    <br />{" "}
                    {!getPastOrderId?.Department
                      ? ""
                      : `${getPastOrderId?.Department?.BusinessUnit?.zipcode}, `}{" "}
                    {!getPastOrderId?.Department
                      ? getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.CityName?._text+', '
                      : getPastOrderId?.Department?.BusinessUnit?.city+', '}
                    {/* , &nbsp; */}
                    {!getPastOrderId?.Department
                      ? ""
                      : `${getPastOrderId?.Department?.BusinessUnit?.state}, `}
                    {!getPastOrderId?.Department
                      ? getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.Country?.IdentificationCode?._text
                      : getPastOrderId?.Department?.BusinessUnit?.country}
                  </p>
                  <p>{t("telephone")}: - ----</p>
                  <p>{t("website")}: - ----</p>
                </div>
                <div className="col-md-6">
                  {/* <h5>{t("title")}</h5> */}
                  <h6>
                    {t("deliveryDate")}{" "}
                    {getPastOrderId?.deliveryDateTime
                      ? moment(getPastOrderId?.deliveryDateTime).format(
                          "DD/MM/YYYY"
                        )
                      : "---"}
                  </h6>
                  <h6>
                    {t("deliveryTime")}
                    {getPastOrderId?.deliveryDateTime
                      ? moment(getPastOrderId?.deliveryDateTime).format(
                          "h:mm A"
                        )
                      : "---"}
                  </h6>
                  <h6>
                    {t("orderId")}:- {getPastOrderId?.id}
                  </h6>
                  <h6>
                    {t("invoiceId")}:-
                    <Link
                      to={`/invoicedetails?id=${getPastOrderId?.orginalInvoiceId}`}
                    >
                      {getPastOrderId?.Invoice?.invoice?.Invoice?.ID?._text}
                    </Link>
                  </h6>
                  <h6>
                    {t("orderStatus")}{" "}
                    <i className="fa-solid fa-circle-check"></i>{" "}
                    {getPastOrderId?.orderStatus}
                  </h6>
                </div>
              </div>
              <div className="row ordervendor">
                <div className="col-md-6">
                  <h6>{t("vendor_title")}</h6>
                  <div className="pd">
                    <span className="pdn">{t("companyName")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PartyName?.Name
                          ?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("contact")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.Contact?.Name?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("addressLine1")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PostalAddress
                          ?.StreetName?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("addressLine2")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PostalAddress
                          ?.CityName?._text+', '
                      }
                      {/* ,{" "} */}
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PostalAddress
                          ?.Country?.IdentificationCode?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("phone")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.Contact?.Telephone
                          ?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("fax")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.Contact
                          ?.ElectronicMail?._text
                      }
                    </span>
                  </div>
                </div>
                <div className="col-md-6">
                  <h6>{t("shipTo.title")}</h6>
                  <div className="pd">
                    <span className="pdn">{t("shipTo.name")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PartyName?.Name
                          ?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("shipTo.companyName")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PartyLegalEntity
                          ?.RegistrationName?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("shipTo.addressLine1")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.StreetName?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("shipTo.addressLine2")}</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.CityName?._text+', '
                      }
                      {/* ,{" "} */}
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.Country?.IdentificationCode?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("shipTo.phone")}</span>{" "}
                    <span>----</span>
                  </div>
                  <div className="pd">
                    <span className="pdn">{t("shipTo.email")}</span>{" "}
                    <span>----</span>
                  </div>
                </div>
              </div>

              <div className="poTable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("itemNumber")}</th>
                      <th>{t("description")}</th>
                      <th>{t("quantity")}</th>
                      <th>{t("quantityReceived")}</th>
                      <th>{t("unitPrice")}</th>
                      <th>{t("discount")}</th>
                      <th>{t("carbonFootprint")}</th>
                      <th>{t("UNSPSC")}</th>
                      <th>{t("total")}</th>
                      <th>Logs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!Array.isArray(
                      getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine
                    ) &&
                      [
                        getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine,
                      ]?.map((d) => (
                        <tr>
                          <td data-label="ITEM #">
                            {d?.Item?.SellersItemIdentification?.ID?._text}
                          </td>
                          <td data-label="Description">
                            {d?.Item?.Name?._text}
                          </td>
                          <td data-label="Qty">{d?.InvoicedQuantity?._text}</td>
                          <td data-label="Qty Rec">
                            {d?.ReceivedQuantity?._text
                              ? d?.ReceivedQuantity?._text
                              : d?.InvoicedQuantity?._text}
                          </td>
                          <td data-label="Unit Price">
                            {currencyData[0]?.name} &nbsp;
                            {formatCurrency(
                              Number(d?.Price?.PriceAmount?._text),
                              currencyData[0]?.name
                            )}
                          </td>
                          <td data-label="Discount">----</td>
                          <td data-label="CARBON FOOTPRINT">{`${
                            d?.co2Print?._text ? d?.co2Print?._text : "----"
                          }`}</td>
                          <td data-label="UNSPSC">
                            {d?.UNSPSC ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id="tooltip"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {d?.UNSPSC?.unspscTitle}
                                  </Tooltip>
                                }
                              >
                                <Button variant="success" className="unspsc">
                                  {`${d?.UNSPSC?.unspscTitle?.slice(0, 10)}${
                                    d?.UNSPSC?.unspscTitle?.length > 10
                                      ? "..."
                                      : ""
                                  }`}
                                </Button>
                              </OverlayTrigger>
                            ) : (
                              "---"
                            )}
                          </td>
                          <td data-label="Total">
                            {currencyData[0]?.name} &nbsp;
                            {formatCurrency(
                              Number(d?.LineExtensionAmount?._text),
                              currencyData[0]?.name
                            )}
                          </td>
                        </tr>
                      ))}
                    {Array.isArray(
                      getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine
                    ) &&
                      getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine?.map(
                        (d) => (
                          <tr>
                            <td data-label="ITEM #">
                              {d?.Item?.SellersItemIdentification?.ID?._text}
                            </td>
                            <td data-label="Description">
                              {d?.Item?.Name?._text}
                            </td>
                            <td data-label="Qty">
                              {d?.InvoicedQuantity?._text}
                            </td>
                            <td data-label="Qty Rec">
                              {d?.ReceivedQuantity?._text
                                ? d?.ReceivedQuantity?._text
                                : d?.InvoicedQuantity?._text}
                            </td>
                            <td data-label="Unit Price">
                              {currencyData[0]?.name} &nbsp;
                              {formatCurrency(
                                Number(d?.Price?.PriceAmount?._text),
                                currencyData[0]?.name
                              )}
                            </td>
                            <td data-label="Discount">----</td>
                            <td data-label="CARBON FOOTPRINT">{`${
                              d?.co2Print?._text ? d?.co2Print?._text : "----"
                            }`}</td>
                            <td
                              data-label="UNSPSC"
                              style={{ textAlign: "center" }}
                            >
                              {d?.UNSPSC ? (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip
                                      id="tooltip"
                                      style={{ fontSize: "10px" }}
                                    >
                                      {d?.UNSPSC?.unspscTitle}
                                    </Tooltip>
                                  }
                                >
                                  <Button variant="success" className="unspsc">
                                    {`${d?.UNSPSC?.unspscTitle?.slice(0, 10)}${
                                      d?.UNSPSC?.unspscTitle?.length > 10
                                        ? "..."
                                        : ""
                                    }`}
                                  </Button>
                                </OverlayTrigger>
                              ) : (
                                "---"
                              )}
                            </td>
                            <td data-label="Total">
                              {currencyData[0]?.name} &nbsp;
                              {formatCurrency(
                                Number(d?.LineExtensionAmount?._text),
                                currencyData[0]?.name
                              )}
                            </td>
                            <td data-label="Total">
                              <i
                                className="fa fa-history"
                                style={{ cursor: "pointer" }}
                                aria-hidden="true"
                                onClick={() =>
                                  handlePurchaseHistory(d?.Item?.Name?._text)
                                }
                              ></i>
                            </td>
                            {/* <td data-label="Total">{Number(d?.LineExtensionAmount?._text).toFixed(2)} {d?.LineExtensionAmount?._attributes?.currencyID}</td> */}
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-md-4 order-md-1">
                  <div className="subtotal">
                    <h6>{t("Subtotal")}: </h6>{" "}
                    <span>
                      {currencyData[0]?.name} &nbsp;
                      {formatCurrency(
                        Number(
                          getPastOrderId?.Invoice?.invoice?.Invoice
                            ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                        ),
                        currencyData[0]?.name
                      )}
                      {/* {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                      }{" "}
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.LegalMonetaryTotal?.LineExtensionAmount?._attributes
                          ?.currencyID
                      } */}
                    </span>
                  </div>
                  <div className="subtotal">
                    <h6>
                      {t("tax")}:{" "}
                      {Number(
                        getPastOrderId?.Invoice?.invoice?.Invoice?.TaxTotal
                          ?.TaxSubtotal?.TaxCategory?.Percent?._text
                      )}
                      %{" "}
                    </h6>{" "}
                    <span className="boxborder">
                      {currencyData[0]?.name} &nbsp;
                      {formatCurrency(
                        Number(
                          Number(
                            (Number(
                              getPastOrderId?.Invoice?.invoice?.Invoice
                                ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                            ) *
                              Number(
                                getPastOrderId?.Invoice?.invoice?.Invoice
                                  ?.TaxTotal?.TaxSubtotal?.TaxCategory?.Percent
                                  ?._text
                              )) /
                              100
                          )
                        ),
                        currencyData[0]?.name
                      )}
                    </span>
                  </div>
                  <div className="subtotal">
                    <h6>{t("shipping")}:</h6>{" "}
                    <span className="boxborder">---</span>
                  </div>
                  <div className="subtotal">
                    <h6>{t("other")}:</h6>{" "}
                    <span className="boxborder">---</span>
                  </div>
                  <div className="subtotal">
                    <h6>{t("shipping")} </h6>{" "}
                    <span className="boxborder">---</span>
                  </div>
                  <div className="subtotal">
                    <h6>{t("other")}: </h6>{" "}
                    <span className="boxborder">---</span>
                  </div>
                  <div className="subtotal">
                    <h6>
                      <strong>{t("Total")}:</strong>{" "}
                    </h6>{" "}
                    <span className="boxborder totl">
                      {currencyData[0]?.name} &nbsp;
                      {formatCurrency(
                        Number(
                          (Number(
                            getPastOrderId?.Invoice?.invoice?.Invoice
                              ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                          ) *
                            Number(
                              getPastOrderId?.Invoice?.invoice?.Invoice
                                ?.TaxTotal?.TaxSubtotal?.TaxCategory?.Percent
                                ?._text
                            )) /
                            100 +
                            Number(
                              getPastOrderId?.Invoice?.invoice?.Invoice
                                ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                            )
                        ),
                        currencyData[0]?.name
                      )}
                      {/* {Number(
                        (Number(
                          getPastOrderId?.Invoice?.invoice?.Invoice
                            ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                        ) *
                          Number(
                            getPastOrderId?.Invoice?.invoice?.Invoice?.TaxTotal
                              ?.TaxSubtotal?.TaxCategory?.Percent?._text
                          )) /
                          100 +
                          Number(
                            getPastOrderId?.Invoice?.invoice?.Invoice
                              ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                          )
                      ).toFixed(2)}{" "}
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.LegalMonetaryTotal?.LineExtensionAmount?._attributes
                          ?.currencyID
                      } */}
                    </span>
                  </div>
                </div>
                <div className="col-md-8">
                  <table className="instruction">
                    <tr>
                      <th>{t("Comments or Special Instructions")}</th>
                    </tr>
                    <tr>
                      <td>
                        {commentk}
                        {/* {`${getPastOrderId?.CommentsLogs[getPastOrderId?.CommentsLogs.length-1]?.comments}`} */}
                        {/* <Form.Control as="textarea" rows={3} placeholder="Comments & special instructions" className='comnt' name='comments' value={comments?.commentk} onChange={onComments} disabled/> */}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="commonBase mb-4">
              <h6 className="mb-3">{t("addGHGKey")}</h6>
              <div
                className="additembox groupBordr"
                style={{ borderRadius: "50px" }}
              >
                <div className="chooseOpt">
                  {/* <input type="text" value={getPastOrderId?.GHG?.key} /> */}
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("ghg_key")}
                  value={
                    getPastOrderId?.GHG?.key
                      ? `(${getPastOrderId?.GHG?.key}) ${getPastOrderId?.GHG?.value}`
                      : ""
                  }
                  disabled
                />
              </div>
            </div>
            {/* Transport Emission */}
            <div className="commonBase mb-4">
              <div className="col-md-12">
                <h5 className="mb-3">{t("transport_emission")}</h5>
                {emissionData?.map((d, index) => (
                  <div className="row align-items-center" key={index}>
                    {/* Transport Type */}
                    <div className="col-md-4 d-flex align-items-center">
                      <label className="m-2" style={{ fontWeight: "bold" }}>
                        {t("transport_type")}:
                      </label>
                      <span className="m-2">{d?.transport_type}</span>
                    </div>

                    {/* Fuel Type */}
                    <div className="col-md-4 d-flex align-items-center">
                      <label className="m-2" style={{ fontWeight: "bold" }}>
                        {t("fuel_type")}:
                      </label>
                      <span className="m-2">{d?.transport_fuel}</span>
                    </div>

                    {/* Distance of Transport */}
                    <div className="col-md-4 d-flex align-items-center">
                      <label
                        className="m-2 form-label text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {t("distance_of_transport")}:
                      </label>
                      <span className="m-2">
                        {d?.transport_distance || "___"} Km
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Waste Package Material */}
            <div className="commonBase mb-4">
              <div className="col-md-12">
                <h5 className="mb-3">{t("waste_packaging_material")}</h5>
                {wasteData?.map((d, index) => (
                  <div className="row align-items-center" key={index}>
                    {/* Material Type */}
                    <div className="col-md-4 d-flex align-items-center">
                      <label className="m-2" style={{ fontWeight: "bold" }}>
                        {t("material_type")}
                      </label>
                      <span className="m-2">{d?.material_type}</span>
                    </div>

                    {/* Distance of Transport */}
                    <div className="col-md-4 d-flex align-items-center">
                      <label
                        className="m-2 form-label text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {t("distance_of_transport")}:
                      </label>
                      <span className="m-2">{d?.quantity || "___"} Kg</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* <div className='commonBase mb-4'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <h6 className='mb-3'>Department Name</h6>
                                <div className='additembox groupBordr'>
                                    <div className='chooseOpt'>

                                    </div>
                                    <input type='text' className='form-control' placeholder='Department Name' value={`${getPastOrderId?.Department?.name ? getPastOrderId?.Department?.name : ""}`} disabled />

                                </div>
                            </div>
                            <div className='col-md-6'>
                                <h6 className='mb-3'>Business Unit Name</h6>
                                <div className='additembox groupBordr'>
                                    <div className='chooseOpt'>

                                    </div>
                                    <input type='text' className='form-control' placeholder='BusinessUnit Name' value={`${getPastOrderId?.Department?.BusinessUnit?.name ? getPastOrderId?.Department?.BusinessUnit?.name : ""}`} disabled />

                                </div>
                            </div>
                        </div>

                    </div> */}
            {/* <div className='commonBase mb-4'>
                        <h6 className='mb-3'>Add GL Key</h6>
                        <div className='additembox groupBordr'>
                        <div className='chooseOpt'>
                      
                            </div>
                            <input type='text' className='form-control' placeholder='GL Key' value={`${getPastOrderId?.GL?.value?getPastOrderId?.GL?.value:""}`} disabled  />
                        </div>
             </div> */}
            <div className="commonBase mb-3">
              <h5>{t("quality_control")}</h5>
              {/* {getPastOrderId?.SelectedPastOrderQualityControls?.map((d, i) => (

                            <div className='qualityBase' key={i}>
                                <p>{d?.QualityControl?.text}  {d?.QualityControl?.id}</p>
                                <div className='radioline invBasis'>
                                    <div className='invLft'>
                                        <input type="radio" id="test1" value={true} name={`name${d?.QualityControl?.id}`} onChange={handleToggle} />
                                        <label for="test1">Yes</label>
                                    </div>&nbsp;&nbsp;
                                    <div className='invrgt'>
                                        <input type="radio" id="test2" value={false} name={`name${d?.QualityControl?.id}`} onChange={handleToggle} />
                                        <label for="test2">No</label>
                                    </div>
                                </div>

                            </div>
                        ))} */}
              {getPastOrderId?.SelectedPastOrderQualityControls?.map((d, i) => (
                <div className="qualityBase" key={i}>
                  <p>{d?.QualityControl?.text}</p>
                  <div className="radioline invBasis">
                    {d?.answer ? (
                      <div
                        style={{ color: d?.answer === "Yes" ? "green" : "red" }}
                      >
                        {d?.answer}
                      </div>
                    ) : (
                      <>
                        <div className="invLft">
                          <input
                            type="radio"
                            id={`test1_${d?.QualityControl?.id}`}
                            value="Yes"
                            name={`name${d?.QualityControl?.id}`}
                            onChange={(e) =>
                              handleToggle(e, d?.QualityControl?.id)
                            }
                          />
                          <label htmlFor={`test1_${d?.QualityControl?.id}`}>
                            {t("yes")}
                          </label>
                        </div>
                        <div className="invrgt">
                          <input
                            type="radio"
                            id={`test2_${d?.QualityControl?.id}`}
                            value="No"
                            name={`name${d?.QualityControl?.id}`}
                            onChange={(e) =>
                              handleToggle(e, d?.QualityControl?.id)
                            }
                          />
                          <label htmlFor={`test2_${d?.QualityControl?.id}`}>
                            {t("no")}
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}

              {!(
                getPastOrderId?.SelectedPastOrderQualityControls?.filter(
                  (item) => !item.answer
                ).length === 0
              ) ? (
                <button className="commonButton mt-3" onClick={onSubmit}>
                  {t("submit")}
                </button>
              ) : (
                ""
              )}
              {/* <button className='commonButton mt-3' onClick={onSubmit}>Submit</button> */}
            </div>
            <div className="commonBase mb-4">
              {/* <div className="d-flex"> */}
              <div className="col-md-12">
                <h5 className="mb-3">{t("orderLogs")}</h5>
                <Link to="javascript:void(0)" onClick={onLogs}>
                  <i className="fa fa-history" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
            <div className="commonBase mb-4">
              {/* <div className="d-flex"> */}
              <div className="col-md-12">
                <h5 className="mb-3">{t("orderStatus")}</h5>
                {["radio"].map((type) => (
                  <div className="additembox adnewbox" key={`OrderStatus`}>
                    <Form.Check
                      disabled
                      reverse
                      label={`${t("Created")}`}
                      name="OrderStatus"
                      type={type}
                      id={`Created`}
                      checked={status === "Created"}
                      // onChange={onStatus}
                      value={"Created"}
                    />
                    <Form.Check
                      disabled
                      reverse
                      label={`${t("receivedWithIssues")}`}
                      name="OrderStatus"
                      type={type}
                      id={`ReceivedWithIssues`}
                      checked={status === "Received,comments"}
                      // onChange={onStatus}
                      value={"Received,comments"}
                    />
                    <Form.Check
                      disabled
                      reverse
                      label={t("Received")}
                      name="OrderStatus"
                      type={type}
                      id={`Received`}
                      checked={status === "Received"}
                      // onChange={onStatus}
                      value={"Received"}
                    />
                    <Form.Check
                      disabled
                      reverse
                      label={t("approvedWithIssues")}
                      name="OrderStatus"
                      type={type}
                      id={`ApprovedWithIssues`}
                      checked={status === "Approved,comments"}
                      // onChange={onStatus}
                      value={"Approved,comments"}
                    />
                    <Form.Check
                      disabled
                      reverse
                      label={t("Approved")}
                      name="OrderStatus"
                      type={type}
                      id={`Approved`}
                      checked={status === "Approved"}
                      // onChange={onStatus}
                      value={"Approved"}
                    />
                    <Form.Check
                      disabled
                      reverse
                      label={t("Rejected")}
                      name="OrderStatus"
                      type={type}
                      id={`Rejected`}
                      checked={status === "Rejected"}
                      // onChange={onStatus}
                      value={"Rejected"}
                    />
                  </div>
                ))}
              </div>
              {/* <div className='col-md-4'>
                            <h6 className='mb-3'>Department Name</h6>
                            <div className='additembox groupBordr'>
                                <div className='chooseOpt'>

                                </div>
                                <input type='text' className='form-control' placeholder='Department Name' value={`${getPastOrderId?.Department?.name ? getPastOrderId?.Department?.name : ""}`} disabled />

                            </div>
                        </div>
                        <div className='col-md-4'>
                            <h6 className='mb-3'>Business Unit Name</h6>
                            <div className='additembox groupBordr'>
                                <div className='chooseOpt'>

                                </div>
                                <input type='text' className='form-control' placeholder='BusinessUnit Name' value={`${getPastOrderId?.Department?.BusinessUnit?.name ? getPastOrderId?.Department?.BusinessUnit?.name : ""}`} disabled />

                            </div>
                        </div> */}
              {/* </div> */}
            </div>
            <div className="commonBase mb-3">
              <h5>{t("accountingInformation")}</h5>
              {/* <div className='aiInput'>
                        <input type="radio" name="type" id="businessUnit" defaultChecked={accoutingInfoType === 'businessUnit'} onChange={e => setAccoutingInfoType('businessUnit')} />&nbsp;&nbsp;<label htmlFor="businessUnit">Business Unit</label>&nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="radio" name="type" id="department" defaultChecked={accoutingInfoType === 'department'} onChange={e => setAccoutingInfoType('department')} />&nbsp;&nbsp;<label htmlFor="department">Department</label>
                        </div> */}
              {
                //     (accoutingInfoType==='businessunit')?
                //     <div className='poTable respTable'>
                //     <table>
                //         <thead>
                //             <tr>
                //                 <th>Business Unit Accounting code</th>
                //                 <th>GL Key</th>
                //                 <th>Dimension 2</th>
                //                 <th>Dimension 3</th>
                //                 <th>Quantity</th>
                //                 <th>Amount</th>
                //                 <th>Currency</th>
                //                 <th>VAT</th>
                //                 {/* <th>Approved by user </th> */}
                //                 <th>User Accounting Key</th>
                //             </tr>
                //         </thead>
                //         <tbody>
                //             {
                //                 accountingInformation.length &&
                //                 accountingInformation.map((item,index)=>{return(
                //                     <tr key={index}>
                //                     <td>{item?.PastOrder?.Department?.BusinessUnit?.accountingKey}</td>
                //                     <td>{item?.PastOrder?.GlKeyId?item?.PastOrder?.GlKeyId:'----'}</td>
                //                     <td>{item?.dimension3?item?.dimension3:'----'}</td>
                //                     <td>{item?.dimension4?item?.dimension4:'----'}</td>
                //                     <td>{item?.totalQty?item?.totalQty:'----'}</td>
                //                     <td>{item?.totalSalePrice?item?.totalSalePrice:'----'}</td>
                //                     <td>{item?.currencyType?item?.currencyType:'----'}</td>
                //                     <td>{item?.VATpercent?item?.VATpercent:'----'}</td>

                //                     <td>{'----'}</td>
                //                 </tr>
                //                 )})

                //             }

                //         </tbody>

                //     </table>
                // </div>:  <></>
                // <div className='poTable respTable'>
                //     <table>
                //         <thead>
                //             <tr>
                //                 <th>Department Unit Accounting code</th>
                //                 <th>GL Key</th>
                //                 <th>Dimension 2</th>
                //                 <th>Dimension 3</th>
                //                 <th>Quantity</th>
                //                 <th>Amount</th>
                //                 <th>Currency</th>
                //                 <th>VAT</th>
                //                 {/* <th>Approved by user </th> */}
                //                 <th>User Accounting Key</th>
                //             </tr>
                //         </thead>
                //         <tbody>
                //             {
                //                               accountingInformation.length &&
                //                               accountingInformation.map((item,index)=>{return(
                //                                   <tr>
                //                                   <td>{item?.PastOrder?.Department?.accountingKey}</td>
                //                                   <td>{'----'}</td>
                //                                   <td>{'----'}</td>
                //                                   <td>{'----'}</td>
                //                                   <td>{'----'}</td>
                //                                   <td>{'----'}</td>
                //                                   <td>{'----'}</td>

                //                                   <td>{'----'}</td>
                //                               </tr>
                //                               )})

                //                 // <tr>
                //                 //     <td>{item?.PastOrder?.Department?.accountingKey}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'----'}</td>
                //                 //     <td>{'name'}</td>
                //                 //     <td>{'----'}</td>
                //                 // </tr>
                //                 // getPastOrderId?.Products?.map((item,index)=>{return(
                //                 //     <tr>
                //                 //     <td data-label="Business Unit">{getPastOrderId?.Department?.BusinessUnit?.name}</td>
                //                 //     <td data-label="Department">{getPastOrderId?.Department?.name}</td>
                //                 //     <td data-label="Accounting Dimensions">{getPastOrderId?.Department?.AccountingInformation?.accountDimension}</td>
                //                 //     <td data-label="UNSPSC">
                //                 //         {item?.unspscSegment?`${item?.unspscSegment?.SegmentTitle}(${item?.unspscSegment?.Segment})`:''}
                //                 //         {item?.unspscFamily?`${item?.unspscFamily?.FamilyTitle}(${item?.unspscFamily?.Family})`:''}
                //                 //         {item?.unspscSegment?`${item?.unspscClass?.ClassTitle}(${item?.unspscClass?.Class})`:''}
                //                 //         {item?.unspscCommodity?`${item?.unspscCommodity?.CommodityTitle}(${item?.unspscCommodity?.Commodity})`:''}

                //                 //         </td>
                //                 //     <td data-label="Currency">{item?.currencyType}</td>
                //                 //     <td data-label="VAT">{item?.VATPercent}</td>
                //                 // </tr>
                //                 // )})
                //             }
                //             {/* <tr>
                //                 <td data-label="Business Unit">Business Unit name</td>
                //                 <td data-label="Department">Department name</td>
                //                 <td data-label="Accounting Dimensions">Accounting Dimensions</td>
                //                 <td data-label="UNSPSC">UNSPSC Desc(UNSPSC KEY)</td>
                //                 <td data-label="Currency">Currency</td>
                //                 <td data-label="VAT">Calculate VAT</td>
                //             </tr>
                //             <tr>
                //                 <td data-label="Business Unit">Business Unit name</td>
                //                 <td data-label="Department">Department name</td>
                //                 <td data-label="Accounting Dimensions">Accounting Dimensions</td>
                //                 <td data-label="UNSPSC">UNSPSC Desc(UNSPSC KEY)</td>
                //                 <td data-label="Currency">Currency</td>
                //                 <td data-label="VAT">Calculate VAT</td>
                //             </tr> */}

                //         </tbody>

                //     </table>
                // </div>

                <div className="poTable respTable aiTable">
                  <table>
                    <thead>
                      <tr>
                        <th>
                          {accoutingInfoType === "businessUnit" ? (
                            <>
                              <span>{t("businessUnit")}</span>
                              <br></br> <span>{t("accountingKey")}</span>
                            </>
                          ) : (
                            <>
                              <span>{t("departmentUnit")}</span>
                              <br></br> <span>{t("accountingKey")}</span>
                            </>
                          )}
                        </th>
                        <th>
                          {
                            accountingInformation[0]?.accountDimension
                              ?.GLFieldName
                          }
                        </th>
                        {/* {accountingInformation?.length > 0 &&
                          accountingInformation[0]?.accountDimension
                            ?.dimension2 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension2FieldName
                              }
                            </th>
                          )}
                        {accountingInformation?.length > 0 &&
                          accountingInformation[0]?.accountDimension
                            ?.dimension3 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension3FieldName
                              }
                            </th>
                          )}
                        {accountingInformation?.length > 0 &&
                          accountingInformation[0]?.accountDimension
                            ?.dimension4 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension4FieldName
                              }
                            </th>
                          )}
                        {accountingInformation?.length > 0 &&
                          accountingInformation[0]?.accountDimension
                            ?.dimension5 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension5FieldName
                              }
                            </th>
                          )}
                        {accountingInformation?.length > 0 &&
                          accountingInformation[0]?.accountDimension
                            ?.dimension6 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension6FieldName
                              }
                            </th>
                          )} */}
                        <th>{t("unspsc")}</th>
                        <th>{t("quantity")}</th>
                        <th>{t("amount")}</th>
                        <th>{t("currency")}</th>
                        <th>{t("vat")}</th>
                        <th>{t("userAccountingKey")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accountingInformation.length > 0 &&
                        accountingInformation.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {accoutingInfoType === "businessUnit"
                                ? item?.PastOrder?.Department?.BusinessUnit
                                    ?.accountingKey
                                : item?.PastOrder?.Department?.accountingKey}
                            </td>
                            <td>
                              {(item?.unspsc &&
                                item?.accountDimension?.GL?.key) ||
                                "----"}
                            </td>

                            {/* {item?.accountDimension?.dimension2 && (
                              <td>{item?.accountDimension?.dimension2}</td>
                            )}
                            {item?.accountDimension?.dimension3 && (
                              <td>{item?.accountDimension?.dimension3}</td>
                            )}
                            {item?.accountDimension?.dimension4 && (
                              <td>{item?.accountDimension?.dimension4}</td>
                            )}
                            {item?.accountDimension?.dimension5 && (
                              <td>{item?.accountDimension?.dimension5}</td>
                            )}
                            {item?.accountDimension?.dimension6 && (
                              <td>{item?.accountDimension?.dimension6}</td>
                            )} */}

                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip
                                  id="tooltip"
                                  style={{ fontSize: "10px" }}
                                >
                                  {item?.unspscSegment?.SegmentTitle ||
                                    item?.unspscFamily?.FamilyTitle ||
                                    item?.unspscClass?.ClassTitle ||
                                    item?.unspscCommodity?.CommodityTitle}
                                </Tooltip>
                              }
                            >
                              <td>{item?.unspsc || "----"}</td>
                            </OverlayTrigger>
                            <td>{item?.totalQty || "----"}</td>
                            <td>{item?.totalSalePrice || "----"}</td>
                            <td>{item?.currencyType || "----"}</td>
                            <td>
                              {item?.VATpercent
                                ? `${item?.VATpercent} %`
                                : "----"}
                            </td>
                            <td>{"----"}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              }
            </div>
            {/* <button className='commonButton'>Send To Supplier</button> */}
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={logs}
        onHide={handleCloseLogs}
        dialogClassName="custom-modal-size"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="mb-3">{t("allLogs")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav
            fill
            variant="tabs"
            defaultActiveKey={activeTab}
            onSelect={handleSelect}
            className="navTb"
          >
            <Nav.Item>
              <Nav.Link eventKey="link-1">{t("qcStatus")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-2">{t("commentStatus")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-3">{t("orderLogs")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-4">{t("quantityLogs")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-5">{t("businessUnitLogs")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-6">{t("ghgKeyLogs")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-7">Transport Emission</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-8">Waste Package Material</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-9">{t("deliveryLogs")}</Nav.Link>
            </Nav.Item>
          </Nav>

          {/* QC Status Logs */}
          {activeTab === "link-1" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("question")}</th>
                    <th>{t("answer")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.SelectedPastOrderQualityControls?.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                  )?.map((s) => (
                    <tr className={isActive ? null : "inactive"}>
                      <td data-label={t("dateTime")}>
                        {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                      </td>
                      <td data-label={t("question")}>
                        {s?.QualityControl?.text}
                      </td>
                      <td
                        data-label={t("answer")}
                        style={{
                          color: s?.answer === "Yes" ? "green" : "red",
                        }}
                      >
                        {s?.answer}&nbsp;
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Comment Status Logs */}
          {activeTab === "link-2" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("user")}</th>
                    <th>{t("comment")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.CommentsLogs?.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                  )?.map((s) => (
                    <tr className={isActive ? null : "inactive"}>
                      <td data-label={t("dateTime")}>
                        {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                      </td>
                      <td data-label={t("user")}>
                        {s?.User.firstName} {s?.User.lastName}
                      </td>
                      <td data-label={t("comment")}>{s?.comments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Order Logs */}
          {activeTab === "link-3" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("user")}</th>
                    <th>{t("orderStatus")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.orderStatusLogs
                    ?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )
                    ?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateTime")}>
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("user")}>
                          {s?.User.firstName} {s?.User.lastName}
                        </td>
                        <td data-label={t("orderStatus")}>{s?.orderStatus}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Quantity Logs */}
          {activeTab === "link-4" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("user")}</th>
                    <th>{t("productName")}</th>
                    <th>{t("quantity")}</th>
                    <th>{t("receivedQuantity")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.QuantityLogs?.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                  )?.map((s) => (
                    <tr className={isActive ? null : "inactive"}>
                      <td data-label={t("dateTime")}>
                        {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                      </td>
                      <td data-label={t("user")}>
                        {s?.User.firstName} {s?.User.lastName}
                      </td>
                      <td data-label={t("productName")}>{s?.item}</td>
                      <td data-label={t("quantity")}>{s?.quantity}</td>
                      <td data-label={t("receivedQuantity")}>
                        {s?.receivedQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Business Unit Logs */}
          {activeTab === "link-5" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("user")}</th>
                    <th>{t("businessUnit")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.businessLogs
                    ?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )
                    ?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateTime")}>
                          {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("user")}>
                          {s?.User?.firstName} {s?.User?.lastName}
                        </td>
                        <td data-label={t("businessUnit")}>
                          {s?.BusinessUnit?.name}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}

          {/* GHG Key Logs */}
          {activeTab === "link-6" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("user")}</th>
                    <th>{t("ghgKey")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.ghgLogs
                    ?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )
                    ?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateTime")}>
                          {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("user")}>
                          {s?.User?.firstName} {s?.User?.lastName}
                        </td>
                        <td data-label={t("ghgKey")}>{s?.MasterGHG?.key}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Delivery Logs */}
          {activeTab === "link-7" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("dateTime")}</th>
                    <th>{t("user")}</th>
                    <th>{t("deliveryDateTime")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allLogs?.deliveryLogs
                    ?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )
                    ?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label={t("dateTime")}>
                          {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label={t("user")}>
                          {s?.User?.firstName} {s?.User?.lastName}
                        </td>
                        <td data-label={t("deliveryDateTime")}>
                          {moment(s?.DeliveryDateTime).format(
                            "DD-MM-YYYY, HH:mm"
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={purchaseHistoriesModal}
        onHide={() => setPurchaseHistoryModal(false)}
        dialogClassName="custom-modal-size"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="mb-3">{t("purchaseHistory")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dbMaintable respTable">
            <table>
              <thead>
                <tr>
                  <th>{t("Order ID")}</th>
                  <th>{t("Order Date")}</th>
                  <th>{t("User")}</th>
                  <th>{t("productNumber")}</th>
                  <th>{t("productName")}</th>
                  <th>{t("Purchase Quantity")}</th>
                  <th>{t("Price")}</th>
                  <th>{t("Change Percentage")}</th>
                </tr>
              </thead>

              <tbody>
                {purchaseHistory?.length > 0 &&
                  purchaseHistory
                    ?.sort(
                      (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
                    )
                    ?.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td data-label="Order ID">
                            <Link to="javascript:void(0)">
                              {/* {item.orderId} */}
                              {item.orderId}
                            </Link>
                          </td>
                          <td data-label="Order Date">
                            <Link to="javascript:void(0)">
                              {moment(item.createdAt).format("DD-MM-YYYY")}
                            </Link>
                          </td>
                          <td data-label="Order Date">
                            <Link to="javascript:void(0)">
                              {`${item?.User?.firstName} ${item?.User?.lastName}`}
                            </Link>
                          </td>
                          <td data-label="Product number">
                            <Link to="javascript:void(0)">
                              {item?.Product?.number}
                            </Link>
                          </td>
                          <td data-label="Product name">
                            <Link to="javascript:void(0)">
                              {item?.Product?.name}
                            </Link>
                          </td>
                          <td data-label="Total Quantity per Base units">
                            <Link to="javascript:void(0)">
                              {item.totalQuantityPerBaseUnits}
                            </Link>
                          </td>
                          <td data-label="Base unit Price">
                            <Link to="javascript:void(0)">
                              {item.currencyType}{" "}
                              {item.baseUnitPrice.toFixed(2)}
                            </Link>
                          </td>
                          <td data-label="Change Percentage">
                            <Link to="javascript:void(0)">
                              {item?.changePercentage
                                ? `${Number(item?.changePercentage).toFixed(
                                    2
                                  )} %`
                                : "----"}
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Pastorderdetail;
